import { createError } from 'h3';

/**
 * Loads the translations of a locale from the translations API.
 *
 * @param headers - Request headers for a server-side call. The API returns the draft translations
 * only for a request with the draft mode cookie.
 */
export async function loadLocaleMessages(locale: string, headers: Record<string, string> = {}) {
    try {
        return await $fetch(`/api/translations/${locale}`, {
            headers,
            timeout: 10_000,
            // The browser must not use the HTTP cache. The cache headers of the API permit stale
            // responses. A revalidation can also return 304 for new translations, because the
            // `If-Modified-Since` check has a precision of one second.
            cache: 'no-store'
        });
    } catch (error) {
        console.error('[i18n] Failed to load translations from API.', error);
        throw createError({
            status: 503,
            statusCode: 503,
            statusMessage: 'Translations temporarily unavailable',
            fatal: true,
            cause: error
        });
    }
}
